import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
  
  /* Styling for react-datepicker */
  .react-datepicker-wrapper {
    width: auto;
  }

  /* Target the input field inside the datepicker */
  .react-datepicker__input-container input {
    width: 100%;
    min-width: 120px;
    padding: 10px 15px;
    border: 1px solid ${({ theme }) => theme.cardBorder};
    border-radius: 8px;
    font-size: 16px;
    background-color: ${({ theme }) => theme.inputBg};
    color: ${({ theme }) => theme.heading};
    font-family: inherit; /* Ensures consistent font */
    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.primary};
    }
  }
`;

export const SearchInput = styled.input`
  flex-grow: 1;
  min-width: 250px;
  padding: 10px 15px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const Select = styled.select`
  padding: 10px 15px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;